import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { authApi } from "../services/adminApi";

const links = [
  { to: "/overview", label: "Overview" },
  { to: "/users", label: "User Management" },
  { to: "/trades", label: "Trade Management" },
  { to: "/team", label: "Team Management" },
  { to: "/withdrawals", label: "Withdrawal Management" },
  { to: "/deposits", label: "Deposit Management" },
  { to: "/licenses", label: "License / Plan" },
  { to: "/finance", label: "Financial Monitoring" },
  { to: "/bonuses", label: "Aiarbix & Bonus" },
  { to: "/logs", label: "Security & Audit" },
  { to: "/operations", label: "Operations" },
];

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const currentLabel =
    links.find((item) => location.pathname.startsWith(item.to))?.label ||
    "Overview";

  const logout = async () => {
    await authApi.logout();
    navigate("/login");
  };

  return (
    <div className="app-shell">
      <button
        type="button"
        className="drawer-toggle"
        onClick={() => setIsDrawerOpen((prev) => !prev)}
      >
        {isDrawerOpen ? "×" : "☰"}
      </button>

      {isDrawerOpen ? (
        <div className="drawer-overlay" onClick={() => setIsDrawerOpen(false)} />
      ) : null}

      <aside className={`sidebar ${isDrawerOpen ? "open" : ""}`}>
        <div className="brand-wrap">
          <div className="brand-icon" aria-hidden="true">
            <img
              src="/logo-icon.png"
              alt=""
              style={{ width: 34, height: 34, objectFit: "contain" }}
            />
          </div>
          <div>
            <div className="brand">Aiarbix Admin</div>
            <div className="muted">Control Center</div>
          </div>
        </div>
        {links.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={() => setIsDrawerOpen(false)}
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            {item.label}
          </NavLink>
        ))}
        <button
          style={{ marginTop: 20 }}
          onClick={async () => {
            setIsDrawerOpen(false);
            await logout();
          }}
        >
          Logout
        </button>
      </aside>
      <main className="content">
        <header className="topbar">
          <div>
            <h2 className="topbar-title">{currentLabel}</h2>
          </div>
        </header>
        <div>{children}</div>
      </main>
    </div>
  );
}
